export default class Course {
	constructor() {
		this.id = '';
		this.name = '';
		this.description = '';
		this.code = '';
		this.machines = [];
	}
}
